/* globals $ */
(function() {
    'use strict';

    var SaveQuoteModal = {};

    SaveQuoteModal.open = function(selectedPackage) {
        var city_pairs = this.itinerarySummary();
        $('#quote-itinerary').val(city_pairs.join('\n')).attr('rows', city_pairs.length);
        $('#quote-airline').val(selectedPackage.validating_carrier);
        $('#quote-faretype-string').val(selectedPackage.fare_type_string);
        $('#quote-faretype').val(selectedPackage.fare_type);
        $('#quote-price').val(selectedPackage.prices.total);
        $('#quote-package-id').val(selectedPackage.package_id);

        $('#save-quote-modal').modal('show');
    };

    SaveQuoteModal.close = function() {
        $('#save-quote-modal').modal('close');
    };

    SaveQuoteModal.itinerarySummary = function() {
        var pairs = [];
        for (var i = 0; i < window.PackageGroupInfo.city_pairs.length; i++) {
            var pair = window.PackageGroupInfo.city_pairs[i];
            var date = window.moment(pair.segments[0].departure_time).format('YYYY-MM-DD');
            pairs.push(
                pair.origin_airport_code + ' → ' + pair.destination_airport_code + ', ' + date
            );
        }
        return pairs;
    };

    window.SaveQuoteModal = SaveQuoteModal;
})();